export const APP_NAME = 'Henddu';
export const APP_KEY = 'henddu';

// Redirect Paths
export const REDIRECT_URL_KEY = 'redirect';
export const HOME_PATH = '/';
export const GHOST_ENTRY_PATH = '/login';

// Navigation Types
export const NAV_TYPE_ROOT = 'root';
export const NAV_TYPE_GROUP = 'group';
export const NAV_TYPE_COLLAPSE = 'collapse';
export const NAV_TYPE_ITEM = 'item';
export const NAV_TYPE_DIVIDER = 'divider';

export const COLORS = [
  'neutral',
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
];

export const CANONICAL_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTH_COLORS = {
  January: '#8ED1FC',
  February: '#7CD9F7',
  March: '#98FB98',
  April: '#90EE90',
  May: '#FFB6C1',
  June: '#FFD700',
  July: '#FFA500',
  August: '#FF8C00',
  September: '#DAA520',
  October: '#CD853F',
  November: '#8B4513',
  December: '#87CEEB',
};

export const ivoryCoastCenter = { lat: 7.539989, lng: -5.54708 };
export const defaultZoom = 6;
